<div id="footer" class="row">
    <div class="col">
        <p>© 2020 Shore Rentals. All rights reserved.</p>
    </div>
</div>